export default __webpack_public_path__ + "static/media/comment.8926aeb1.svg";